if(_SCLayoutCollections === undefined){
    function SCLayoutCollections() { }

    var _SCLayoutCollections = {

        emit:function(name){
            var colorBG = "#1e98ec"
            if(name==="productUnvalid"){
                colorBG = "red"
            }
            if(name==="productValid"){
                colorBG = "green"
            }
            console.log("%c→ EMIT SCLayoutCollections." + name,"background:"+colorBG+";color:#FFF")
            console.log({arguments})
            $(document).trigger('SCLayoutCollections.'+name,arguments);
        },

        _init: SCLayoutProducts.prototype.init,
        init:function() {
            this._init();
        }
    }

    //heritage de detail
    SCLayoutCollections.prototype= _.merge(SCLayoutProducts.prototype,_SCLayoutCollections);
    console.log("%cRENDER SC.layout-collections.js","background:yellow;color:#333")

}